import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ResponseConfirmProductsReceivingConfin } from 'src/app/_models';
import { AuthenticationService } from 'src/app/_services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-confirm-product-receiving',
  templateUrl: './confirm-product-receiving.component.html',
  styleUrls: ['./confirm-product-receiving.component.css']
})
export class ConfirmProductReceivingComponent implements OnInit,AfterViewInit {
  FormularioConfirmar:FormGroup;
  ArrayLocations = [];
  Error:String;
  constructor(
    private _httpClient: HttpClient,
    private authenticationService: AuthenticationService,
    private formbuider: FormBuilder,
    public dialogRef: MatDialogRef<ConfirmProductReceivingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ResponseConfirmProductsReceivingConfin) {
      this.ArrayLocations = [];
    }
  ngAfterViewInit(): void {
    this.OnChangeData();
  }
  ngOnInit(): void {
    this.FormularioConfirmar=this.formbuider.group({
      Quantity:[""],
      PalletAmount:[""],
      location:[""],
      Notes:[""]

    })
    this.OnSelectLocations();
  }
  OnChangeData(){
    console.log(this.data)
    this.FormularioConfirmar.controls.Quantity.setValue(this.data.StatedQuantity)
    this.FormularioConfirmar.controls.PalletAmount.setValue(this.data.PalletAmount)
    this.FormularioConfirmar.controls.location.setValue(this.data.LocationID)
    this.FormularioConfirmar.controls.Notes.setValue(this.data.Notes)
  }
  OnSelectLocations() {
    var Request = {};
    Request['companyId'] = Number(
      this.authenticationService.currentUserValue.companyIdWh
    );

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/SerchLocations`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token,
          }),
        }
      )
      .subscribe((response: any) => {
        this.ArrayLocations = response;
      });
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  OnConfirmar() {
    var Request = {};
    Request['tipo'] = Number(
     this.data.Id
    );
    Request['tblProductID'] = Number(
      this.data.productID
     );
     Request['AvailableQuantity'] = String(
      this.FormularioConfirmar.controls.Quantity.value
     );
     Request['tblLocationID'] = Number(
      this.FormularioConfirmar.controls.location.value
     );
     Request['Notes'] = String(
      this.FormularioConfirmar.controls.Notes.value
     );
     Request['PalletAmount'] = Number(
      this.FormularioConfirmar.controls.PalletAmount.value
     );
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Receive/ReceivingConfirmProductUpdate`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token,
          }),
        }
      )
      .subscribe((response: any) => {
     if(response.responses=="success"){
this.onNoClick();
     }else{

this.Error="Error";
     }
      });
  }
}
